import {
  TCS_REPORT_REQUEST,
  TCS_REPORT_SUCCESS,
  TCS_REPORT_FAILURE
} from "../types/tcs-report-types";

const initialState = {
  tcsReport: {},
  loading: false,
  error: null,
};

const tcsReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case TCS_REPORT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case TCS_REPORT_SUCCESS: {
      return {
        ...state,
        tcsReport: {...(action.payload || {})},
        loading: false,
        error: null
      };
    }
    case TCS_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default tcsReportReducer;
